import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Avatar({ name, bg = '#4F9E9C', size = 32, ring = false, title }) {
    const ch = (name || '?').slice(0, 1).toUpperCase();
    return (_jsx("div", { className: "tt-avatar", title: title ?? name, style: {
            width: size,
            height: size,
            background: bg,
            fontSize: size * 0.42,
            boxShadow: ring ? '0 0 0 2px #fff' : undefined,
        }, children: ch }));
}
export function AvatarStack({ members, max = 4 }) {
    const show = members.slice(0, max);
    const extra = members.length - show.length;
    return (_jsxs("div", { style: { display: 'flex' }, children: [show.map((m, i) => (_jsx("div", { style: { marginLeft: i === 0 ? 0 : -8 }, children: _jsx(Avatar, { name: m.name, bg: m.avatar_color, size: 32, ring: true }) }, m.id))), extra > 0 && (_jsxs("div", { className: "tt-avatar", style: {
                    width: 32, height: 32, marginLeft: -8,
                    background: 'var(--ink-200)', color: 'var(--ink-700)', fontSize: 12,
                    boxShadow: '0 0 0 2px #fff',
                }, children: ["+", extra] }))] }));
}
